import { registerModuleClicks } from "@shared/lingxi/kit";
import "./macros/xiaochengxuhua";

registerModuleClicks(require("./lingxi.json"));

require("./product-detail.less");